import { useCanViewSetup } from "@/hooks";
import { Navigate, Outlet } from "react-router-dom";

export const RoutesGuard = ({ children }: { children?: JSX.Element }) => {
  const canViewSetup = useCanViewSetup();

  if (!canViewSetup) {
    return <Navigate to={"/home"} />;
  }

  return children ? children : <Outlet />;
};
